module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter2"
  }, [_vm._v("Robbery of Cayke the Cookie Cook")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan019.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter1"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One more important theft was reported in the Land of Oz that eventful morning, but it took place so far from either the Emerald City or the castle of Glinda the Good that none of those persons we have mentioned learned of the robbery until long afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the far southwestern corner of the Winkie Country is a broad tableland that can be reached only by climbing a steep hill, whichever side one approaches it. On the hillside surrounding this tableland are no paths at all, but there are quantities of bramble-bushes with sharp prickers on them, which prevent any of the Oz people who live down below from climbing up to see what is on top. But on top live the Yips, and although the space they occupy is not great in extent the wee country is all their own. The Yips had never—up to the time this story begins—left their broad tableland to go down into the Land of Oz, nor had the Oz people ever climbed up to the country of the Yips."), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Living all alone as they did, the Yips had queer ways and notions of their own and did not resemble any other people of the Land of Oz. Their houses were scattered all over the flat surface; not like a city, grouped together, but set wherever their owners’ fancy dictated, with fields here, trees there, and odd little paths connecting the houses one with another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was here, on the morning when Ozma so strangely disappeared from the Emerald City, that Cayke the Cookie Cook discovered that her diamond-studded gold dishpan had been stolen, and she raised such a hue-and-cry over her loss and wailed and shrieked so loudly that many of the Yips gathered around her house to inquire what was the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a serious thing, in any part of the Land of Oz, to accuse one of stealing, so when the Yips heard Cayke the Cookie Cook declare that her jeweled dishpan had been stolen they were both humiliated and disturbed and forced Cayke to go with them to the Frogman to see what could be done about it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("I do not suppose you have ever before heard of the Frogman, for like all other dwellers on that tableland he had never been away from it, nor had anyone come up there to see him. The Frogman was, in truth, descended from the common frogs of Oz, and when he was first born he lived in a pool in the Winkie Country and was much like any other frog. Being of an adventurous nature, however, he soon hopped out of his pool and began to travel, when a big bird came along and seized him in its beak and started to fly away with him to its nest. When high in the air the frog wriggled so frantically that he got loose and fell down—down—down into a small hidden pool on the tableland of the Yips. Now this pool, it seems, was unknown to the Yips because it was surrounded by thick bushes and was not near to any dwelling, and it proved to be an enchanted pool, for the frog grew very fast and very big, feeding on the magic skosh which is found nowhere else on earth except in that one pool. And the skosh not only made the frog very big, so that when he")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v(" stood on his hind legs he was tall as any Yip in the country, but it made him unusually intelligent, so that he soon knew more than the Yips did and was able to reason and to argue very well indeed.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan020.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one could expect a frog with these talents to remain in a hidden pool, so he finally got out of it and mingled with the people of the tableland, who were amazed at his appearance and greatly impressed by his learning. They had never seen a frog before and the frog had never seen a Yip before, but as there were plenty of Yips and only one frog, the frog became the most important. He did not hop any more, but stood upright on his hind legs and dressed himself in fine clothes and sat in chairs and did all the things that people do; so he soon came to be called the Frogman, and that is the only name he has ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After some years had passed the people came to regard the Frogman as their adviser in all matters that puzzled them. They brought all their difficulties to him and when he did not know anything he pretended to know it, which seemed to answer just as well. Indeed, the Yips thought the Frogman was much wiser than he really was, and he allowed them to think so, being very proud of his position of authority.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another pool on the tableland, which was not enchanted but contained good clear water and was located close to the dwellings. Here the people built the Frogman a house of his own, close to the edge of the pool, so that he could take a bath or a swim whenever he wished. He usually swam in the pool in the early morning, before anyone else was up, and during the day he dressed himself in his beautiful clothes and sat in his house and received the visits of all the Yips who came to him to ask his advice.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The Frogman’s usual costume consisted of knee-breeches made of yellow satin plush, with trimmings of gold braid and jeweled knee-buckles; a white satin vest with silver buttons in")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v(" which were set solitaire rubies; a swallow-tailed coat of bright yellow; green stockings and red leather shoes turned up at the toes and having diamond buckles. He wore, when he walked out, a purple silk hat and carried a gold-headed cane. Over his eyes he wore great spectacles with gold rims, not because his eyes were bad but because the spectacles made him look wise, and so distinguished and gorgeous was his appearance that all the Yips were very proud of him.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no King or Queen in the Yip Country, so the simple inhabitants naturally came to look upon the Frogman as their leader as well as their counselor in all times of emergency. In his heart the big frog knew he was no wiser than the Yips, but for a frog to know as much as a person was quite remarkable, and the Frogman was shrewd enough to make the people believe he was far more wise than he really was. They never suspected he was a humbug, but listened to his words with great respect and did just what he advised them to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, when Cayke the Cookie Cook raised such an outcry over the theft of her diamond-studded dishpan, the first thought of the people was to take her to the Frogman and inform him of the loss, thinking that of course he could tell her where to find it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He listened to the story with his big eyes wide open behind his spectacles, and said in his deep, croaking voice:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If the dishpan is stolen, somebody must have taken it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But who?” asked Cayke, anxiously. “Who is the thief?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The one who took the dishpan, of course,” replied the Frogman, and hearing this all the Yips nodded their heads gravely and said to one another:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is absolutely true!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I want my dishpan!” cried Cayke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one can blame you for that wish,” remarked the Frogman.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“Then tell me where I may find it,” she urged.")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan021.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING IN THE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IP")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTRY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VER")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TOLEN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The look the Frogman gave her was a very wise look and he rose from his chair and strutted up and down the room with his hands under his coat-tails, in a very pompous and imposing manner. This was the first time so difficult a matter had been brought to him and he wanted time to think. It would never do to let them suspect his ignorance and so he thought very, very hard how best to answer the woman without betraying himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I beg to inform you,” said he, “that nothing in the Yip Country has ever been stolen before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We know that, already,” answered Cayke the Cookie Cook, impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Therefore,” continued the Frogman, “this theft becomes a very important matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, where is my dishpan?” demanded the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is lost; but it must be found. Unfortunately, we have no policemen or detectives to unravel the mystery, so we must employ other means to regain the lost article. Cayke must first write a Proclamation and tack it to the door of her house, and the Proclamation must read that whoever stole the jeweled dishpan must return it at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But suppose no one returns it,” suggested Cayke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then,” said the Frogman, “that very fact will be proof that no one has stolen it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cayke was not satisfied, but the other Yips seemed to approve the plan highly. They all advised her to do as the Frogman had told her to, so she posted the sign on her door and waited patiently for someone to return the dishpan—which no one ever did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again she went, accompanied by a group of her neighbors, to the Frogman, who by this time had given the matter considerable thought. Said he to Cayke:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“I am now convinced that no Yip has taken your dishpan, and, since it is gone from the Yip Country, I suspect that some")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v(" stranger came from the world down below us, in the darkness of night when all of us were asleep, and took away your treasure. There can be no other explanation of its disappearance. So, if you wish to recover that golden, diamond-studded dishpan, you must go into the lower world after it.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This was indeed a startling proposition. Cayke and her friends went to the edge of the flat tableland and looked down the steep hillside to the plains below. It was so far to the bottom of the hill that nothing there could be seen very distinctly and it seemed to the Yips very venturesome, if not dangerous, to go so far from home into an unknown land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, Cayke wanted her dishpan very badly, so she turned to her friends and asked:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who will go with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one answered this question, but after a period of silence one of the Yips said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We know what is here, on the top of this flat hill, and it seems to us a very pleasant place; but what is down below we do not know. The chances are it is not so pleasant, so we had best stay where we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It may be a far better country than this is,” suggested the Cookie Cook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe, maybe,” responded another Yip, “but why take chances? Contentment with one’s lot is true wisdom. Perhaps, in some other country, there are better cookies than you cook; but as we have always eaten your cookies, and liked them—except when they are burned on the bottom—we do not long for any better ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cayke might have agreed to this argument had she not been so anxious to find her precious dishpan, but now she exclaimed impatiently:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("“You are cowards—all of you! If none of you are willing to explore with me the great world beyond this small hill, I will surely go alone.”")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan022.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is a wise resolve,” declared the Yips, much relieved. “It is your dishpan that is lost, not ours; and, if you are willing to risk your life and liberty to regain it, no one can deny you the privilege.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While they were thus conversing the Frogman joined them and looked down at the plain with his hig eyes and seemed unusually thoughtful. In fact, the Frogman was thinking that he’d like to see more of the world. Here in the Yip Country he had become the most important creature of them all and his importance was getting to be a little tame. It would be nice to have other people defer to him and ask his advice and there seemed no reason, so far as he could see, why his fame should not spread throughout all Oz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He knew nothing of the rest of the world, but it was reasonable to believe that there were more people beyond the mountain where he now lived than there were Yips, and if he went among them he could surprise them with his display of wisdom and make them bow down to him as the Yips did. In other words, the Frogman was ambitious to become still greater than he was, which was impossible if he always remained upon this mountain. He wanted others to see his gorgeous clothes and listen to his solemn sayings, and here was an excuse for him to get away from the Yip Country. So he said to Cayke the Cookie Cook:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" will go with you, my good woman,” which greatly pleased Cayke because she felt the Frogman could be of much assistance to her in her search.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("But now, since the mighty Frogman had decided to undertake the journey, several of the Yips who were young and daring at once made up their minds to go along; so the next morning after breakfast the Frogman and Cayke the Cookie Cook and nine of the Yips started to slide down the side of the mountain. The bramble-hushes and cactus plants were very prickly and uncomfortable to the touch, so the Frogman commanded the Yips to go first and break a path, so that when he followed")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v(" them he would not tear his splendid clothes. Cayke, too, was wearing her best dress, and was likewise afraid of the thorns and prickers, so she kept behind the Frogman.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They made rather slow progress and night overtook them before they were halfway down the mountain side, so they found a cave in which they sought shelter until morning. Cayke had brought along a basket full of her famous cookies, so they all had plenty to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the second day the Yips began to wish they had not embarked on this adventure. They grumbled a good deal at having to cut away the thorns to make the path for the Frogman and the Cookie Cook, for their own clothing suffered many tears, while Cayke and the Frogman traveled safely and in comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it is true that anyone came to our country to steal your diamond dishpan,” said one of the Yips to Cayke, “it must have been a bird, for no person in the form of a man, woman or child could have climbed through these bushes and back again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And, allowing he could have done so,” said another Yip, “the diamond-studded gold dishpan would not have repaid him for his troubles and his tribulations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For my part,” remarked a third Yip, “I would rather go back home and dig and polish some more diamonds, and mine some more gold, and make you another dishpan, than be scratched from head to heel by these dreadful bushes. Even now, if my mother saw me, she would not know I am her son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cayke paid no heed to these mutterings, nor did the Frogman. Although their journey was slow it was being made easy for them by the Yips, so they had nothing to complain of and no desire to turn back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Quite near to the bottom of the great hill they came upon a deep gulf, the sides of which were as smooth as glass. The gulf extended a long distance—as far as they could see, in either direction—and although it was not very wide it was far too wide")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v(" for the Yips to leap across it. And, should they fall into it, it was likely they might never get out again.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here our journey ends,” said the Yips. “We must go back again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cayke the Cookie Cook began to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I shall never find my pretty dishpan again—and my heart will be broken!” she sobbed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Frogman went to the edge of the gulf and with his eye carefully measured the distance to the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Being a frog,” said he, “I can leap, as all frogs do; and, being so big and strong, I am sure I can leap across this gulf with ease. But the rest of you, not being frogs, must return the way you came.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We will do that with pleasure,” cried the Yips and at once they turned and began to climb up the steep mountain, feeling they had had quite enough of this unsatisfactory adventure. Cayke the Cookie Cook did not go with them, however. She sat on a rock and wept and wailed and was very miserable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” said the Frogman to her, “I will now bid you goodbye. If I find your diamond decorated gold dishpan I will promise to see that it is safely returned to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I prefer to find it myself!” she said. “See here, Frogman, why can’t you carry me across the gulf when you leap it? You are big and strong, while I am small and thin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Frogman gravely thought over this suggestion. It was a fact that Cayke the Cookie Cook was not a heavy person. Perhaps he could leap the gulf with her on his back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you are willing to risk a fall,” said he, “I will make the attempt.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("At once she sprang up and grabbed him around his neck with both her arms. That is, she grabbed him where his neck ought to be, for the Frogman had no neck at all. Then he squatted down, as frogs do when they leap, and with his powerful rear legs he made a tremendous jump.")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan023.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the gulf he sailed, with the Cookie Cook on his back, and he had leaped so hard—to make sure of not falling in—that he sailed over a lot of bramble-bushes that grew on the other side and landed in a clear space which was so far beyond the gulf that when they looked back they could not see it at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cayke now got off the Frogman’s back and he stood erect again and carefully brushed the dust from his velvet coat and rearranged his white satin necktie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had no idea I could leap so far,” he said wonderingly. “Leaping is one more accomplishment I can now add to the long list of deeds I am able to perform.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are certainly fine at leap-frog,” said the Cookie Cook, admiringly; “but, as you say, you are wonderful in many ways. If we meet with any people down here I am sure they will consider you the greatest and grandest of all living creatures.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” he replied, “I shall probably astonish strangers, because they have never before had the pleasure of seeing me. Also they will marvel at my great learning. Every time I open my mouth, Cayke, I am liable to say something important.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is true,” she agreed, “and it is fortunate your mouth is so very wide and opens so far, for otherwise all the wisdom might not be able to get out of it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Perhaps nature made it wide for that very reason,” said the Frogman: “But come; let us now go on, for it is getting late and we must find some sort of shelter before night overtakes us.”")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan024.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ce70ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/07_Chapter_3.vue
// module id = 84
// module chunks = 0